import { render, staticRenderFns } from "./WikiDataCommon.vue?vue&type=template&id=20a7e458"
import script from "./WikiDataCommon.vue?vue&type=script&lang=ts"
export * from "./WikiDataCommon.vue?vue&type=script&lang=ts"
import style0 from "./WikiDataCommon.vue?vue&type=style&index=0&id=20a7e458&prod&lang=css"
import style1 from "./WikiDataCommon.vue?vue&type=style&index=1&id=20a7e458&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports